module.exports = __webpack_public_path__ + "static/media/1-18.7d81adcf.mp3";